/**
 * Whether prices should be hidden on the current website. Mirrors the `HidePrices`
 * website field, exposed by ClientContext.cshtml.
 */
export const hidePrices = () =>
    window.__litium?.requestContext?.hidePrices === true;
